import React from "react";
import { Search, Filter, Plus, ShoppingCart } from "lucide-react";

export default function AdminOrdersHeader({
  total,
  searchQuery, setSearchQuery,
  showFilters, setShowFilters,
  onPlacedOrderClick, onCreateOrderClick,
}) {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-bold text-[--text-primary]" style={{ fontFamily: "Playfair Display, serif" }}>
          Admin Orders
        </h1>
        <p className="text-sm text-[--text-muted]">{total} orders total</p>
      </div>

      <div className="flex items-center gap-2">
        <div className="relative flex-1 md:w-64">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[--text-muted]" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search orders..."
            className="w-full pl-9 pr-4 py-2 text-sm bg-white border border-[--border] rounded-lg focus:ring-2 focus:ring-[--accent] outline-none"
            data-testid="search-orders-input"
          />
        </div>
        <button
          onClick={() => setShowFilters(!showFilters)}
          className={`btn-icon ${showFilters ? "bg-[--accent-pale] text-[--accent]" : ""}`}
          data-testid="toggle-filters-btn"
        >
          <Filter size={16} />
        </button>
        <button onClick={onPlacedOrderClick} className="btn-secondary text-sm py-2 px-3 flex items-center gap-1.5" data-testid="placed-order-btn">
          <ShoppingCart size={14} /> Placed Order
        </button>
        <button onClick={onCreateOrderClick} className="btn-primary text-sm py-2 px-3 flex items-center gap-1.5" data-testid="create-order-btn">
          <Plus size={14} /> Create Order
        </button>
      </div>
    </div>
  );
}
